import { Controller } from "@hotwired/stimulus"

// Nationality picker. The <select> (rendered server-side with <optgroup>s for
// "Frequent" and each continent) is the primary submitted field — this
// controller only adds client-side filtering on top via a sibling text input.
// With JS off, the plain <select> still works: progressive enhancement.
export default class extends Controller {
  static targets = ["select", "filter"]

  filter() {
    const query = this.filterTarget.value.trim().toLowerCase()

    Array.from(this.selectTarget.children).forEach((child) => {
      if (child.tagName === "OPTGROUP") {
        this.#filterOptgroup(child, query)
      } else if (child.tagName === "OPTION") {
        this.#setOptionVisible(child, this.#matches(child, query))
      }
    })
  }

  #filterOptgroup(optgroup, query) {
    let anyVisible = false

    Array.from(optgroup.children).forEach((option) => {
      const visible = this.#matches(option, query)
      this.#setOptionVisible(option, visible)
      if (visible) anyVisible = true
    })

    optgroup.hidden = !anyVisible
  }

  #matches(option, query) {
    // The Unspecified option (value="") is never hidden by the filter.
    if (option.value === "") return true
    if (query === "") return true

    return option.textContent.trim().toLowerCase().includes(query)
  }

  #setOptionVisible(option, visible) {
    option.hidden = !visible
  }
}
